import * as THREE from 'three';
import { Env } from './Env';

export class Scene {

    static scene: THREE.Scene;

    static cubeID: number;

    constructor() {
        const scene = new THREE.Scene();
        // scene.fog = new THREE.Fog(0xffffff, 20000 * Env.size_units, 50000 * Env.size_units);
        scene.background = new THREE.Color(0xffffff);
        Scene.scene = scene;
        if (!Env.panels_position && !Env.cabinets_cart_data) {
            Scene.showCube();
        }
    }

    static showCube(): void {
        const cube = new THREE.Mesh(new THREE.BoxGeometry(1,1,1), new THREE.MeshStandardMaterial({color:0xaaaaff}));
        Scene.cubeID = cube.id;
        Scene.scene.add(cube);
    }

    static removeCube(): void {
        const cube = Scene.scene.getObjectById(Scene.cubeID);
        cube?.parent?.remove(cube);
    }
}